/**
 * Created by richardlovejoy on 3/23/17.
 */

import DisplayHelpers from '../utils/misc/DisplayHelpers';
import GameSounds from '../sound/GameSounds';

class SoundControlWidget extends Phaser.Group {

  constructor(game, label, volumeProperty, soundOnValue = 1) {
    super(game);

    this.name = 'SoundControlWidget';
    this.soundOnValue = soundOnValue;
    this.volumeProperty = volumeProperty;

    this.init(label);
  }

  init(labelFrame) {
    this.turnSoundOffIcon = this.game.add.image(0, 0, 'skee', 'soundOnicon.png', this);
    this.turnSoundOnIcon = this.game.add.image(0, 0, 'skee', 'soundOfficon.png', this);
    this.turnSoundOffIcon.anchor.setTo(0, 0.5);
    this.turnSoundOnIcon.anchor.setTo(0, 0.5);
    this.label = this.game.add.image(this.turnSoundOffIcon.width + 4, 0, 'skee', labelFrame, this);
    this.label.anchor.setTo(0, 0.5);

    this.btn = DisplayHelpers.makeHitButton(0, 0, this.turnSoundOffIcon.width+this.label.width, this.turnSoundOffIcon.height, this.handleToggleSound, this, this);
    this.btn.anchor.setTo(0, 0.5);

    // show initial state
    this.refresh();
  }

  reset() {

  }

  toggleLabel(isVisible) {
    this.label.visible = isVisible;
  }

  frameUpdate(){

  }

  refresh() {
    const soundOn = this.game.soundManager[this.volumeProperty] > 0;

    this.turnSoundOffIcon.visible = soundOn;
    this.turnSoundOnIcon.visible = !soundOn;
  }

  handleToggleSound() {
    this.game.soundManager.playSound(GameSounds.SOUND_BUTTON_PRESS);

    // save last volume setting so we can turn it back on
    const currentVolume = this.game.soundManager[this.volumeProperty];

    this.game.soundManager[this.volumeProperty] = (currentVolume > 0) ? 0 : this.soundOnValue;

    this.refresh();
  }

  _turnSoundOn() {
    this.game.soundManager.unmute();
  }

  _turnSoundOff() {
    this.game.soundManager.mute();
  }
}

export default SoundControlWidget;



// WEBPACK FOOTER //
// ./app/src/display/SoundControlWidget.js